// extracted by mini-css-extract-plugin
module.exports = {"c_m_i":"c_m_i-3Coqlcxh","btn":"btn-1vZg4tqT"};